export default __webpack_public_path__ + "static/media/gallery_01.6fd810c2.jpg";